import ResearchShowcaseCardModel from '../ResearchShowcase/ResearchShowcaseCard'
import { BaseModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { fillOwnProperties } from '~/shared/utils/helpers'
import { ImageService } from '~/services/Misc/ImageService'
import VideoCardModel from '~/model/Cards/VideoCardModel'

export default class SpeakerCardModel extends BaseModel {
  id: number = 0
  name: string = ''
  'middle_name': string = ''
  'last_name': string = ''
  'position': string = ''
  photo: string = ''
  description?: string = ''
  videos?: VideoCardModel[] = []
  'research_showcases'?: ResearchShowcaseCardModel[] = []

  constructor(data: unknown) {
    super()
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      if (data.photo) {
        this.photo = new ImageService().cropImage(data.photo, {})
      }

      if (Array.isArray(data.videos)) {
        this.videos = data.videos.map(i => new VideoCardModel(i))
      }

      if (Array.isArray(data.research_showcases)) {
        this.research_showcases = data.research_showcases.map(i => new ResearchShowcaseCardModel(i))
      }
    }
  }
}
